/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for SchoolBillController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { BillPayDto, RequestOptions, PaymentResponseDto, FeesInputDto, FeesDto, SchoolBillDto, SchemaResponse, PagedModelSchoolBillDto, PagedModelSchoolBillInfo } from "../models";

@Injectable({ providedIn: "root" })
export class SchoolBillControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    payAnticipated(billPayDto: BillPayDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    payAnticipated(billPayDto: BillPayDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    payAnticipated(billPayDto: BillPayDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    payAnticipated(billPayDto: BillPayDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/pay/anticipated`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: billPayDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    payAnticipated1(billPayDto: BillPayDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    payAnticipated1(billPayDto: BillPayDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    payAnticipated1(billPayDto: BillPayDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    payAnticipated1(billPayDto: BillPayDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/pay/anticipated`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: billPayDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    pay(billPayDto: BillPayDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    pay(billPayDto: BillPayDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    pay(billPayDto: BillPayDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    pay(billPayDto: BillPayDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/pay`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: billPayDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    pay1(billPayDto: BillPayDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    pay1(billPayDto: BillPayDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    pay1(billPayDto: BillPayDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    pay1(billPayDto: BillPayDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/pay`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: billPayDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFeesAndTaxes(feesInputDto: FeesInputDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<FeesDto>;
    getFeesAndTaxes(feesInputDto: FeesInputDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<FeesDto>>;
    getFeesAndTaxes(feesInputDto: FeesInputDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<FeesDto>>;
    getFeesAndTaxes(feesInputDto: FeesInputDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/fees-taxes`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: feesInputDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFeesAndTaxes1(feesInputDto: FeesInputDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<FeesDto>;
    getFeesAndTaxes1(feesInputDto: FeesInputDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<FeesDto>>;
    getFeesAndTaxes1(feesInputDto: FeesInputDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<FeesDto>>;
    getFeesAndTaxes1(feesInputDto: FeesInputDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/fees-taxes`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: feesInputDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findBillByStudent(idStudent: string, idSchool: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<SchoolBillDto>>;
    findBillByStudent(idStudent: string, idSchool: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<SchoolBillDto>>>;
    findBillByStudent(idStudent: string, idSchool: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<SchoolBillDto>>>;
    findBillByStudent(idStudent: string, idSchool: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills`;

        let params = new HttpParams();
        if (idStudent != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idStudent, 'idStudent');
        }
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    loadFile(file: Blob, idSchool: number, billType: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    loadFile(file: Blob, idSchool: number, billType: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    loadFile(file: Blob, idSchool: number, billType: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    loadFile(file: Blob, idSchool: number, billType: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (billType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, billType, 'billType');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }

        return this.httpClient.request('post', url, {
            body: formData,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findBillByStudent1(idStudent: string, idSchool: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<SchoolBillDto>>;
    findBillByStudent1(idStudent: string, idSchool: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<SchoolBillDto>>>;
    findBillByStudent1(idStudent: string, idSchool: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<SchoolBillDto>>>;
    findBillByStudent1(idStudent: string, idSchool: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills`;

        let params = new HttpParams();
        if (idStudent != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idStudent, 'idStudent');
        }
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    loadFile1(file: Blob, idSchool: number, billType: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    loadFile1(file: Blob, idSchool: number, billType: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    loadFile1(file: Blob, idSchool: number, billType: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    loadFile1(file: Blob, idSchool: number, billType: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (billType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, billType, 'billType');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }

        return this.httpClient.request('post', url, {
            body: formData,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    stop(observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    stop(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    stop(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    stop(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/stop`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    stop1(observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    stop1(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    stop1(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    stop1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/stop`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findStudent(idStudent: string, idSchool: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<SchoolBillDto>;
    findStudent(idStudent: string, idSchool: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<SchoolBillDto>>;
    findStudent(idStudent: string, idSchool: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<SchoolBillDto>>;
    findStudent(idStudent: string, idSchool: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/student`;

        let params = new HttpParams();
        if (idStudent != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idStudent, 'idStudent');
        }
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findStudent1(idStudent: string, idSchool: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<SchoolBillDto>;
    findStudent1(idStudent: string, idSchool: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<SchoolBillDto>>;
    findStudent1(idStudent: string, idSchool: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<SchoolBillDto>>;
    findStudent1(idStudent: string, idSchool: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/student`;

        let params = new HttpParams();
        if (idStudent != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idStudent, 'idStudent');
        }
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAccountSchema(idSchool: number, startDate: string, endDate: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<SchemaResponse>;
    getAccountSchema(idSchool: number, startDate: string, endDate: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<SchemaResponse>>;
    getAccountSchema(idSchool: number, startDate: string, endDate: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<SchemaResponse>>;
    getAccountSchema(idSchool: number, startDate: string, endDate: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/schema`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAccountSchema1(idSchool: number, startDate: string, endDate: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<SchemaResponse>;
    getAccountSchema1(idSchool: number, startDate: string, endDate: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<SchemaResponse>>;
    getAccountSchema1(idSchool: number, startDate: string, endDate: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<SchemaResponse>>;
    getAccountSchema1(idSchool: number, startDate: string, endDate: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/schema`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFilesContent(idSchool: number, fileName: string, billType?: string, size?: number, page?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelSchoolBillDto>;
    getFilesContent(idSchool: number, fileName: string, billType?: string, size?: number, page?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelSchoolBillDto>>;
    getFilesContent(idSchool: number, fileName: string, billType?: string, size?: number, page?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelSchoolBillDto>>;
    getFilesContent(idSchool: number, fileName: string, billType?: string, size?: number, page?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/files/content`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (fileName != null) {
            params = HttpParamsBuilder.addToHttpParams(params, fileName, 'fileName');
        }
        if (billType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, billType, 'billType');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFilesContent1(idSchool: number, fileName: string, billType?: string, size?: number, page?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelSchoolBillDto>;
    getFilesContent1(idSchool: number, fileName: string, billType?: string, size?: number, page?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelSchoolBillDto>>;
    getFilesContent1(idSchool: number, fileName: string, billType?: string, size?: number, page?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelSchoolBillDto>>;
    getFilesContent1(idSchool: number, fileName: string, billType?: string, size?: number, page?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/files/content`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (fileName != null) {
            params = HttpParamsBuilder.addToHttpParams(params, fileName, 'fileName');
        }
        if (billType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, billType, 'billType');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFilesInfo(idSchool: number, page?: number, size?: number, billType?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelSchoolBillInfo>;
    getFilesInfo(idSchool: number, page?: number, size?: number, billType?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelSchoolBillInfo>>;
    getFilesInfo(idSchool: number, page?: number, size?: number, billType?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelSchoolBillInfo>>;
    getFilesInfo(idSchool: number, page?: number, size?: number, billType?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/files`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }
        if (billType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, billType, 'billType');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFilesInfo1(idSchool: number, page?: number, size?: number, billType?: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelSchoolBillInfo>;
    getFilesInfo1(idSchool: number, page?: number, size?: number, billType?: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelSchoolBillInfo>>;
    getFilesInfo1(idSchool: number, page?: number, size?: number, billType?: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelSchoolBillInfo>>;
    getFilesInfo1(idSchool: number, page?: number, size?: number, billType?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/files`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }
        if (billType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, billType, 'billType');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFees(reference: string, paymentMode: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<number>;
    getFees(reference: string, paymentMode: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<number>>;
    getFees(reference: string, paymentMode: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<number>>;
    getFees(reference: string, paymentMode: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/schools/bills/fees`;

        let params = new HttpParams();
        if (reference != null) {
            params = HttpParamsBuilder.addToHttpParams(params, reference, 'reference');
        }
        if (paymentMode != null) {
            params = HttpParamsBuilder.addToHttpParams(params, paymentMode, 'paymentMode');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getFees1(reference: string, paymentMode: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<number>;
    getFees1(reference: string, paymentMode: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<number>>;
    getFees1(reference: string, paymentMode: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<number>>;
    getFees1(reference: string, paymentMode: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/bills/fees`;

        let params = new HttpParams();
        if (reference != null) {
            params = HttpParamsBuilder.addToHttpParams(params, reference, 'reference');
        }
        if (paymentMode != null) {
            params = HttpParamsBuilder.addToHttpParams(params, paymentMode, 'paymentMode');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
